import { connect } from 'react-redux';
import MagicLinkPasswordPage from 'pages/MagicLinkPasswordPage';
import Actions from 'store/auth/actions';

const mapStateToProps = state => {
  return {
    isValidating: state.auth.isValidating,
    validatedData: state.auth.validatedData,
    setPasswordData: state.auth.setPasswordData,
    isSettingPassword: state.auth.isSettingPassword,
  };
};

const mapDispatchToProps = {
  validateMagicLink: Actions.Creators.validateMagicLinkRequest,
  resetValidatedData: Actions.Creators.resetValidatedData,
  setPasswordMagicLink: Actions.Creators.setPasswordMagicLinkRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(MagicLinkPasswordPage);
